import lottie from 'lottie-web';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const InitLottie = () => {
  document.querySelectorAll('[data-animation-path]').forEach((el) => {
    const anim = lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: true,
      autoplay: false, // ★ 수동 제어
      path: el.getAttribute('data-animation-path'),
      rendererSettings: { progressiveLoad: true },
    });

    ScrollTrigger.create({
      trigger: el,
      start: 'top bottom', // 요소 top이 화면 하단에 닿으면
      end: 'bottom top', // 요소 bottom이 화면 상단을 지나면
      onEnter: () => !prefersReduced() && anim.play(),
      onEnterBack: () => !prefersReduced() && anim.play(),
      onLeave: () => anim.pause(),
      onLeaveBack: () => anim.pause(),
    });
  });

  // 옵션: 이미지 로드 후 정확한 위치 재계산
  window.addEventListener('load', () => ScrollTrigger.refresh());

  function prefersReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
};
export default InitLottie;
